// Daily hours constraint: For each day and for each user, the sum of
// assigned event durations for that day must be <= dailyMaxHours.
// Requires:
// - model.optimizationIndexes: { users, eventDateYmd, eventDuration, staffRequiredByRole, decisionVariables }
// Params:
// - dailyMaxHours: number (default 10)
export function buildDailyHoursConstraints(model, params = {}) {
  const idx = model?.optimizationIndexes || {};
  const usersMap = idx.users || {}; // U# -> userId
  const eventDateYmd = idx.eventDateYmd || {}; // E# -> 'YYYY-MM-DD'
  // Use integer minutes to avoid fractional coefficients
  const eventMinutes = idx.eventEffectiveMinutes || idx.eventDurationMinutes || {}; // E# -> minutes
  const staffRequiredByRole = idx.staffRequiredByRole || {}; // E# -> { R#: count }
  const declared = new Set(Object.keys(idx.decisionVariables || {}));

  const dailyMax = Number(params?.dailyMaxHours) > 0 ? Number(params.dailyMaxHours) : 10;
  const dailyMaxMin = Math.round(dailyMax * 60);

  // Group events by date
  const byDate = {};
  for (const [eKey, ymd] of Object.entries(eventDateYmd)) {
    if (!ymd) continue;
    if (!byDate[ymd]) byDate[ymd] = [];
    byDate[ymd].push(eKey);
  }

  const constraints = [];
  for (const eKeys of Object.values(byDate)) {
    const eventsForDay = Array.isArray(eKeys) ? eKeys : [];
    for (const userKey of Object.keys(usersMap)) {
      const vars = [];
      const coeffs = [];
      for (const eKey of eventsForDay) {
        const roles = Object.keys(staffRequiredByRole[eKey] || {});
        for (const rKey of roles) {
          const name = `x_${userKey}_${eKey}_${rKey}`;
          if (declared.has(name)) {
            vars.push(name);
            coeffs.push(Math.max(0, Math.round(Number(eventMinutes[eKey] || 0))));
          }
        }
      }
      if (!vars.length) continue;
      constraints.push({ linear: { vars, coeffs }, domain: [-100000000, dailyMaxMin] });
    }
  }

  return constraints;
}
